'use client';

import { ReactElement } from 'react';
import {
    BadgePercent as BadgePercentIcon,
    CreditCard as CreditCardIcon,
    Info as InfoIcon,
    type LucideIcon,
    Truck as TruckIcon,
} from 'lucide-react';

import { BorderCard, Flex, Heading, Icon, Text } from '@nutralab/ui';

import { classNames } from '@m1work/shared-utils';

import styles from './ServiceAdvantageCard.module.scss';

interface ServiceAdvantageCardProps extends React.HTMLAttributes<HTMLDivElement> {
    title: string;
    subtitle: string;
    icon: string;
}

const KEY_TO_ICON: Record<string, LucideIcon> = {
    truck: TruckIcon,
    'credit-card': CreditCardIcon,
    'badge-percent': BadgePercentIcon,
    info: InfoIcon,
};

/** One service advantage of the home page: icon, title and text. */
export function ServiceAdvantageCard({
    className,
    title,
    subtitle,
    icon,
    ...props
}: ServiceAdvantageCardProps): ReactElement {
    const IconComponent = KEY_TO_ICON[icon] ?? InfoIcon;

    return (
        <BorderCard className={classNames(styles['service-advantage-card'], className)} {...props}>
            <Flex direction="column" align="center">
                <div className={classNames(styles.advantage, 'mb-10')}>
                    <Icon icon={IconComponent} size="3xl" className={styles.icon} />
                </div>

                <Heading className="mb-4" size="xl" weight="semibold" align="center">
                    {title}
                </Heading>

                <Text size="xl" weight="snug" align="center">
                    {subtitle}
                </Text>
            </Flex>
        </BorderCard>
    );
}
